import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { KpiLayout } from "components/OverviewPages/KPIs/KpiLayout";
import Tooltip from "@mui/material/Tooltip";

import { ReactComponent as CaseIcon } from "assets/img/KPIIcons/case.svg";
import { styled } from "@mui/material/styles";
import { CaseManagementParamsContext } from "contexts/CaseManagementParamsContext";

import { CaseStatusCategory } from "interfaces/case-status-type";
import { useGetCaseStatusTypes } from "hooks/case-status-types/useCaseStatusTypes";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";

export function FleetCaseSummaryKpi({ site, machine }) {
  const history = useHistory();
  const { setTableState } = useContext(CaseManagementParamsContext);

  const url = site?.id
    ? `cases/summary?groups=site&open=true&site_id=${site.id}`
    : machine?.id
    ? `cases/summary?groups=site&open=true&machine_id=${machine.id}`
    : "cases/summary?groups=site&open=true";

  const { loading, response: openCasesResponse } = useFetchGetV2(url);

  const openCasesCount = useMemo(() => {
    return openCasesResponse?.reduce(
      (casesOpen, { count }) => casesOpen + count,
      0
    );
  }, [openCasesResponse]);

  const {
    loading: caseStatusTypeLoading,
    caseStatusTypes
  } = useGetCaseStatusTypes();

  const filteredCaseStatusTypes = useMemo(() => {
    let statusTypes = [];
    if (caseStatusTypes) {
      statusTypes = caseStatusTypes.filter(
        caseStatusType =>
          caseStatusType.category !== CaseStatusCategory.COMPLETE
      );
    }
    return statusTypes;
  }, [caseStatusTypes]);

  const onCaseSummaryClicked = () => {
    setTableState(state => ({
      ...state,
      filters: {
        Status: filteredCaseStatusTypes ?? [],
        Site: site?.name ? [{ name: site?.name, id: site?.id }] : [],
        Machine: machine?.name ? [{ name: machine?.name, id: machine?.id }] : []
      },
      pageIndex: 0
    }));

    history.push("/pages/case-management");
  };

  return (
    <KpiLayout
      title="Cases Open"
      loading={
        loading || caseStatusTypeLoading || typeof openCasesCount !== "number"
      }
      Icon={CaseIcon}
      cursorEnable={!loading}
      onClickEvent={() => !loading && onCaseSummaryClicked()}
    >
      <KpiBody>
        <Tooltip title="Open cases" aria-label="opened-cases">
          <KpiOpenCases>{openCasesCount}</KpiOpenCases>
        </Tooltip>
      </KpiBody>
    </KpiLayout>
  );
}

const KpiBody = styled("div")`
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  height: 48px;
`;

const KpiOpenCases = styled("span")`
  color: #485057;
`;

FleetCaseSummaryKpi.propTypes = {
  expanded: PropTypes.bool.isRequired,
  fleet: PropTypes.bool,
  site: PropTypes.object,
  machine: PropTypes.object
};
